const setIntervalAt = seconds => fn =>
  setInterval(fn, seconds * 1000);

export const everySecondRun = setIntervalAt(1);



// WEBPACK FOOTER //
// ./src/helpers/interval.js